import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import CardPreview from './CardPreview';
import BankPreview from './BankPreview';
import Setup from './Setup';

export default function Wrapper({ paymentMethod }) {
  const paymentMethodType = paymentMethod?.attributes?.payment_method_type;

  return (
    <>
      <h4 className="mb-4">Payment Method</h4>
      <Row>
        {paymentMethod !== null && paymentMethod.attributes.payment_method_status !== '' ? (
          <>
            <Col lg="6" className="d-flex align-items-center mb-3 mb-lg-0">
              {paymentMethodType === 'card' && (
              <CardPreview paymentMethodOptions={paymentMethod.attributes.options} />
              )}

              {paymentMethodType === 'us_bank_account' && (
              <BankPreview paymentMethodOptions={paymentMethod.attributes.options} />
              )}
            </Col>

            <Col lg="6">
              <Setup paymentMethod={paymentMethod} />
            </Col>
          </>
        ) : (
          <Col
            lg={{ span: 8, offset: 2 }}
            xl={{ span: 6, offset: 3 }}
          >
            <Setup paymentMethod={paymentMethod} />
          </Col>
        )}
      </Row>
    </>
  );
}

Wrapper.propTypes = {
  paymentMethod: PropTypes.object,
};

Wrapper.defaultProps = {
  paymentMethod: null,
};
